import { createSelector } from 'reselect';

import { MANUAL_TYPES } from 'constants/LockerConstants';

export const getState = state => state.lockers;

const getId = (_, id) => id;

const getIds = getId;

const getData = createSelector(getState, state => state.data);

export const getAllLockers = createSelector(getData, data => data.byId);

export const getLockerById = createSelector(getAllLockers, getId, (lockers, id) => lockers[id]);

export const getLockersByIds = createSelector(getAllLockers, getIds, (lockers, ids) => ids.map(id => lockers[id]));

export const isLoading = createSelector(getData, data => data.isLoading);

export const hasError = createSelector(getData, data => data.apiError !== null);

export const getPlanningUi = createSelector(getState, state => state.ui.planning);

export const getActionsUi = createSelector(getState, state => state.ui.actions || {});

const getDetailsUi = createSelector(getState, state => state.ui.details);

export const isManualLocker = createSelector(
  getLockerById,
  ({ physicalConfig = {} }) => physicalConfig.type === MANUAL_TYPES.MANUAL
);

const getDetailsModalVisibility = createSelector(getDetailsUi, ui => ui.modalVisibility);

export const canDisplayPrepareConfirmModal = createSelector(
  getDetailsModalVisibility,
  visibility => visibility.preparationConfirm
);

export const canDisplayUnprepareConfirmModal = createSelector(
  getDetailsModalVisibility,
  visibility => visibility.unprepareConfirm
);

export const canDisplayVerifyConfirmModal = createSelector(
  getDetailsModalVisibility,
  visibility => visibility.verificationConfirm
);

export const getSelectedLockerId = createSelector(getData, data => data.selectedLockerId);

export const getSelectedLocker = createSelector(
  getAllLockers,
  getSelectedLockerId,
  (allIds, lockerId) => allIds?.[lockerId]
);

// ACTIONS

const getPrepare = createSelector(getActionsUi, actions => actions.prepare || {});

const getUnprepare = createSelector(getActionsUi, actions => actions.unprepare || {});

const getVerify = createSelector(getActionsUi, actions => actions.verify || {});

export const getPrepareIsLoading = createSelector(getPrepare, state => state.isLoading);

export const getPrepareApiError = createSelector(getPrepare, state => state.apiError);

export const getVerifyIsLoading = createSelector(getVerify, state => state.isLoading);

export const getVerifyApiError = createSelector(getVerify, state => state.apiError);

export const getUnprepareIsLoading = createSelector(getUnprepare, state => state.isLoading);

export const getUnprepareApiError = createSelector(getUnprepare, state => state.apiError);

const getCodeUpdateState = createSelector(getActionsUi, ui => ui.codeUpdate);

const getModalUpdateState = createSelector(getCodeUpdateState, state => state.modal);

const getGeneratedCodeState = createSelector(getCodeUpdateState, state => state.randomCode);

const getValidateCodeState = createSelector(getCodeUpdateState, state => state.validate);

export const isGeneratingRandomCode = createSelector(getGeneratedCodeState, state => state.isLoading);

const isValidatingCode = createSelector(getValidateCodeState, state => state.isLoading);

export const isValidCode = createSelector(getValidateCodeState, state => state.isValid);

export const getUpdatingCode = createSelector(getModalUpdateState, state => state.code);

export const isUpdateModalOpen = createSelector(getModalUpdateState, state => state.isVisible);

export const getUpdatingVaultId = createSelector(getModalUpdateState, state => state.vaultId);

const isUpdateCodeButtonLoading = createSelector(
  isValidatingCode,
  isGeneratingRandomCode,
  (isValidating, isGenerating) => isValidating || isGenerating
);

export const isUpdateCodeButtonDisabled = createSelector(
  isValidCode,
  isUpdateCodeButtonLoading,
  (isValid, isFetching) => !isValid || isFetching
);

export const isUpdatingCode = createSelector(getModalUpdateState, state => state.isFetching);

export const getGeneratedCodeError = createSelector(getGeneratedCodeState, state => state.apiError);
